export enum PageType {
  PAGE_HUB = 'page_hub',
  PAGE_GENERAL = 'page_general',
  PAGE_CATEGORY = 'page_category',
  PAGE_GLOBAL_HOME = 'page_global_home',
  PAGE_PRODUCT_LINE = 'page_product_line',
  PAGE_ARTICLE_LIST = 'page_article_list',
  PAGE_ARTICLE = 'page_article',
}
